import type { IntroStatus } from '@app/shared';

/** How a spoken introduction ended between two reads of the profile (the API: done, or back to pending). */
export function introOutcome(prev: IntroStatus | undefined, next: IntroStatus): 'done' | 'failed' | null {
  if (prev !== 'processing') return null;
  if (next === 'done') return 'done';
  if (next === 'pending') return 'failed';
  return null;
}
